module.exports = __webpack_public_path__ + "static/media/logo_vpbank.6ef6f992.svg";